// Copyright (c) 2024, The SBSE Hub
// License: GNU General Public License v3. See license.txt

if (!window.afiworkerp) window.afiworkerp = {};

afiworkerp.subscribe_to_newsletter = function (opts, btn) {
	return afiworkerp.call({
		type: "POST",
		method: "afiworkerp.email.doctype.newsletter.newsletter.subscribe",
		btn: btn,
		args: { "email": opts.email },
		callback: opts.callback
	});
}
